import * as yup from 'yup'

export const createInviteSchema = yup.object().shape({
  crm: yup
    .string()
    .transform((value) => (value || '').replace(/\s+/g, ''))
    .required('Informe o CRM'),
  crmUf: yup.string().required('Selecione o CRMUF'),
  companyIds: yup
    .array()
    .min(1, 'Selecione ao menos uma empresa')
    .required('Selecione ao menos uma empresa')
})
